import { get } from "lodash";
import { Store } from "redux";
import {
  CATCH_PHRASE_DEFAULT,
  MAX_WINNERS_HIGHLIGHT,
  MODAL_TITLE_DEFAULT
} from "../constants";

export const getCatchPhrase = (store: Store) =>
  get(store, "capi.messages.previousWinnersCatchPhrase", CATCH_PHRASE_DEFAULT);

export const getModalTitle = (store: Store) =>
  get(store, "capi.messages.previousWinnersTitle", MODAL_TITLE_DEFAULT);

export const getMaxWinnersHighlight = (store: Store) =>
  get(store, "capi.messages.maxWinnersHighlight", MAX_WINNERS_HIGHLIGHT);
